module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"emailStatus":{"processed":"Inviato","delivered":"Consegnato","open":"Aperto","click":"Click","dropped":"drop","bounce":"bounce","spamreport":"spam","deferred":"deferred"}}}')
  delete Component.options._Ctor
}
